// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'e-page-500',
  templateUrl: 'page-500.component.html',
  imports: [TranslateModule],
})
export class Page500Component {
}
